import EventEmitter from "eventemitter3";

const EventManager = new EventEmitter();

export { EventManager }